export const WIDGET_CONTRIBUTION_TYPE = 'contribution';
